export default __webpack_public_path__ + "assets/icon-minus-white.d298bb69.svg";